import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useMessagesUI } from '../../contexts/MessagesUIContext';
import '../../styles/UnreadMessagesModal.css';

const UnreadMessagesModal = ({ unreadCount, onDismiss }) => {
  const { openMessages } = useMessagesUI();

  if (!unreadCount || unreadCount <= 0) return null;

  const handleView = () => {
    onDismiss();
    openMessages();
  };

  return (
    <div className="unread-messages-overlay">
      <div className="unread-messages-modal">
        <button
          className="unread-messages-close"
          onClick={onDismiss}
          aria-label="Dismiss"
          type="button"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="unread-messages-icon">
          <FontAwesomeIcon icon={faComment} size="2x" />
        </div>
        <h3>You have unread messages</h3>
        <p>
          You have <strong>{unreadCount}</strong> unread conversation{unreadCount !== 1 ? 's' : ''}.
          These are separate from system alerts.
        </p>
        <div className="unread-messages-actions">
          <button type="button" className="btn-dismiss" onClick={onDismiss}>
            Dismiss
          </button>
          <button type="button" className="btn-view" onClick={handleView}>
            View Messages
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnreadMessagesModal;
